import React from 'react'
import PropTypes from 'prop-types'

const FileInput = ({
  fileFieldName,
  fileFieldId,
  onChange,
  labelTitle,
  isDisabled,
  multiple,
  className = '',
  accept = NaN,
}) => (
  <>
    <label
      htmlFor={fileFieldId}
      className={`cursor-pointer inline-block ${className ? className : isDisabled ? 'underline text-gray-500' : 'underline text-blue-500'}`}
    >
      {labelTitle}
    </label>
    <input
      type="file"
      name={fileFieldName}
      id={fileFieldId}
      onClick={(e) => (e.target.value = null)}
      onChange={onChange}
      style={{ position: 'absolute', opacity: 0, zIndex: -1 }}
      disabled={isDisabled || false}
      multiple={multiple}
      accept={accept ? accept : undefined}
    />
  </>
)

FileInput.defaultProps = {
  multiple: false,
}

FileInput.propTypes = {
  fileFieldName: PropTypes.string.isRequired,
  fileFieldId: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  labelTitle: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  multiple: PropTypes.bool,
  className: PropTypes.string,
}

export default FileInput
